import { h, Component } from 'preact';

import {
	Scene,
	OrthographicCamera,
	WebGL1Renderer,
	Mesh,
	ShaderMaterial,
	PlaneGeometry,
	VideoTexture,
} from 'three';

import {
	vertexShader,
	fragmentShader
} from './shaders';
import { joinClasses } from 'utils/utils';

import Store from 'store/store';

import s from 'components/bolt/maskAnimation/maskAnimation.sss';

const GIFT_LOOP_BEGINNING = 0.77;
const GIFT_LOOP_END = 4.4;
const CONTENT_PAGE_TRIGGER = 1.2;

export default class MaskAnimation extends Component {
	constructor(props) {
		super(props);

		this.isLooping = true;
		this.animating = false;
		this.contentPageTriggered = false;

		this.state = {
			isBackground: this.props.isGiftPage
		};

		this.initThree = this.initThree.bind(this);
		this.animate = this.animate.bind(this);
		this.onResize = this.onResize.bind(this);
		this.onEnded = this.onEnded.bind(this);
		this.onScrollToPortals = this.onScrollToPortals.bind(this);
		this.onPageShow = this.onPageShow.bind(this);
		this.onPageHide = this.onPageHide.bind(this);
		this.onPlay = this.onPlay.bind(this);

		Store.on('PORTALS_BUTTON_CLICKED', this.onScrollToPortals);
		Store.on('PAGE_SHOW', this.onPageShow);
		Store.on('PAGE_HIDE', this.onPageHide);
	}

	componentWillUnmount() {
		window.cancelAnimationFrame(this.animationFrame);
		window.clearTimeout(this.transitionEndingTimeout);
		window.removeEventListener('resize', this.resize);
		Store.off('PORTALS_BUTTON_CLICKED', this.onScrollToPortals);
		Store.off('PAGE_SHOW', this.onPageShow);
		Store.off('PAGE_HIDE', this.onPageHide);
	}

	initThree() {
		if (this.scene) {
			this.finalTransitionTriggered = false;
			this.isLooping = this.props.isGiftPage;
			this.setState({ isBackground: this.props.isGiftPage });
			return this.video.play()
				.then(this.animate)
				.catch(() => console.log('video error 1'));
		}
		this.scene = new Scene();
		const width = window.innerWidth;
		const height = window.innerHeight;
		this.camera = new OrthographicCamera(width / - 2, width / 2, height / 2, height / - 2, 0, 10);
		this.camera.position.z = 1;

		this.renderer = new WebGL1Renderer({ alpha: true });
		this.renderer.setSize( width, height );
		this.wrapper.appendChild(this.renderer.domElement);
		const videoTexture = new VideoTexture(this.video);
		const videoHeight = this.video.videoHeight / 2;
		const videoWidth = this.video.videoWidth;
		const videoAspectRatio = videoWidth / videoHeight;
		const viewportAspectRatio = width / height;
		const planeHeight = videoAspectRatio < viewportAspectRatio ? (width / videoAspectRatio) : height;
		const planeWidth = videoAspectRatio < viewportAspectRatio ? width : (height * videoAspectRatio);

		const geometry = new PlaneGeometry(planeWidth, planeHeight);

		this.uniforms = {
			texture: { value: videoTexture }
		};

		const material = new ShaderMaterial({
			vertexShader,
			fragmentShader,
			uniforms: this.uniforms,
			transparent: false,
			depthWrite: false,
			depthTest: false
		});

		const mesh = new Mesh(geometry, material);
		window.addEventListener('resize', this.onResize);

		this.scene.add(mesh);
		this.video.play()
			.then(this.animate)
			.catch((err) => console.log('video error 2', err));
	}

	animate() {
		this.renderer.render(this.scene, this.camera);
		if (!this.animating) {
			this.animating = true;
		}
		if (this.props.isGiftPage) {
			if (this.isLooping && this.video.currentTime >= GIFT_LOOP_END) {
				this.video.currentTime = GIFT_LOOP_BEGINNING;
			} else if (!this.finalTransitionTriggered && !this.isLooping && this.video.currentTime >= GIFT_LOOP_END) {
				this.transitionEndingTimeout = window.setTimeout(() => {
					this.setState({ isBackground: false });
					Store.emit('FINAL_TRANSITION_ENDING');
				}, 1000);
				this.finalTransitionTriggered = true;
			}
		} else {
			if (!this.contentPageTriggered && this.video.currentTime >= CONTENT_PAGE_TRIGGER) {
				Store.emit('CONTENT_TRANSITION_ENDED');
				this.contentPageTriggered = true;
			}
		}
		this.animationFrame = window.requestAnimationFrame(this.animate);
	}

	onResize() {
		this.renderer.setPixelRatio(1.5);
		this.renderer.setSize(window.innerWidth, window.innerHeight);
	}

	onEnded() {
		this.video.currentTime = 0;
		if (this.props.isGiftPage && this.isLooping) {
			this.video.play();
		} else {
			window.cancelAnimationFrame(this.animationFrame);
			this.animating = false;
		}
	}

	onScrollToPortals() {
		this.isLooping = false;
	}

	onPageHide() {
		if (this.animating) {
			this.video.pause();
		}
	}

	onPageShow() {
		if (this.animating) {
			this.video.play()
				.then(this.animate);
		}
	}

	onPlay() {

	}

	render({ resolution, video = {}, key }, { isBackground }) {
		let videoSrc = video[resolution] || '';
		const isIOS = Store.get().client.isIOS;
		if (Store.get().supportsWebm && !isIOS) {
			videoSrc = videoSrc.replace('mp4', 'webm');
		}
		return (
			<div ref={ref => this.wrapper = ref} class={joinClasses(s.wrapper, isBackground && s.background, !videoSrc && s.hidden)} key={key}>
				<video
					id={isBackground ? 'transitionGift' : 'transitionContent'}
					crossOrigin="anonymous"
					src={videoSrc}
					style={{ position: 'absolute', height: '0px' }}
					ref={ref => this.video = ref}
					playsinline
					muted
					onEnded={this.onEnded}
					onPlay={this.onPlay}
				/>
			</div>
		);
	}
}
